module.exports = __webpack_public_path__ + "media/images/double-sided-arrow-93a02e37946a147f2ad759d6dc76546a.svg";